export default "/images/duplicate-icon.png?4bd0713a4d449f45268f2cda5ddfa78d";